import { Navigate } from 'react-router-dom';
import OverviewPage from './OverviewPage';
import { useIsLgUp } from '../hooks/useIsLgUp';

/** Desktop: Overview dashboard. Mobile: jump straight to Order Management. */
const AdminMobileHomeRedirect = () => {
  const isLgUp = useIsLgUp();

  if (!isLgUp) {
    return <Navigate to="/admin/orders" replace />;
  }

  return <OverviewPage />;
};

export default AdminMobileHomeRedirect;
